import { sort } from 'ramda';
import { EType, IMedia } from '../../../../../packages/Carousel/shared/types/media';
import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { IOfferPhoto } from '../../types/offer';

export const media: TComputedPropMapper<IMedia[]> = ({ offer }) => {
  return sort<IOfferPhoto>((a, b) => Number(b.isDefault) - Number(a.isDefault), offer.photos || []).map(photo => ({
    type: photo.isLayout ? EType.Layout : EType.Photo,
    url: photo.thumbnail2Url,
  }));
};
